import { createSelector } from 'reselect'
import { dialogsSelector } from '../store/flow/selectors/dialogsSelector'

import { slugify } from '../lib/transliterate/slugify'

const stepTypeDefaultsDefault = {}

export const getStepTypeDefaultsSelector = createSelector(
  ({ flow }) => (flow.present && flow.present.stepTypeDefaults) || stepTypeDefaultsDefault,
  defaults => defaults
)

export const getStepsSelector = dialogId => {
  return createSelector(dialogsSelector, dialogs => {
    if (!dialogs[dialogId]) {
      return []
    }

    return dialogs[dialogId].steps
  })
}

export const getStepCountSelector = dialogId => {
  return createSelector(getStepsSelector(dialogId), steps => steps.length)
}

export const getLastStepTypeSelector = dialogId => {
  return createSelector(
    getStepsSelector(dialogId),
    getStepCountSelector(dialogId),
    (steps, stepCount) => {
      if (!stepCount) {
        return
      }

      return steps[stepCount - 1].type
    }
  )
}

export const getNameSelector = dialogId => {
  return createSelector(
    dialogsSelector,
    dialogs => Object.values(dialogs).find(dialog => slugify(dialog.id) === dialogId)?.name // note: it is possible that exists unslugified dialog IDs created in past
  )
}
